import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
declare var Chart: any;

@Component({
  selector: 'app-add-rapport-visite',
  templateUrl: './add-rapport-visite.component.html',
  styleUrls: ['./add-rapport-visite.component.scss'],
})
export class AddRapportVisiteComponent implements OnInit {
  constructor(public generalService: GeneralService) {}
  date_Debut: Date;
  isNewUser = true;
  CRM_DS: any;
  refrech = false;
  client: any = {
    Tiers_code: null,
  };
  ngOnInit(): void {
    this.generalService.getDS('CRMActivity').subscribe((ds) => {
      this.CRM_DS = ds;
    });
  }
  ChampEnter() {
    this.isNewUser = true;
    this.generalService
      .rechercheTable2('API_TiersCord', this.client.Tiers_code)
      .subscribe((res) => {
        this.client = { ...res[0] };
        this.isNewUser = false;
      });
  }
  clientBlur() {
    console.log(this.isNewUser);

    if (this.isNewUser && this.client.Tiers_code) {
      if (!confirm('souhaitez-vous ajouter un nouvel utilisateur'))
        this.client.Tiers_code = null;
    }
  }
  async enregistrer() {
    if (!this.validForm()) {
      this.generalService.dialogSuccess(
        'merci de vérifier les données saisies',
        false,
        2000
      );
      return;
    }
    // check if user is new and add it
    if (this.isNewUser) {
      var clientDS: any = await this.generalService
        .getDS('Prospect')
        .toPromise();
      clientDS.Tiers[0].Tiers_RS = this.client.Tiers_code;
      clientDS.Tiers[0].Tiers_Type = 2;
      clientDS.Tiers[0].Tiers_Adresse = this.client.Tiers_Adresse;
      clientDS.Tiers[0].Tiers_Contact_Nom = this.client.Tiers_Contact_Nom;
      clientDS.Tiers[0].Tiers_Contact_mail = this.client.Tiers_Contact_mail;
      clientDS.Tiers[0].Tiers_Contact_Tel = this.client.Tiers_Contact_Tel;
      const res: any = await this.generalService.postDs(clientDS).toPromise();
      this.client.Tiers_code = res.code;
    }
    let d = new Date(this.CRM_DS.CRMActivity[0].CRMActivity_Date);
    d.setDate(d.getDate() + 1);
    this.CRM_DS.CRMActivity[0].CRMActivity_Date = d;
    this.CRM_DS.CRMActivity[0].Tiers_code = this.client.Tiers_code;
    this.CRM_DS.CRMActivity[0].CRMActivity_Type = 5;
    this.generalService.postDs(this.CRM_DS).subscribe(() => {
      this.generalService.dialogSuccess(
        'Le rapport a été ajouté avec succès',
        true,
        2000
      );
      this.client = {
        Tiers_code: null,
      };
      this.CRM_DS = null;
      this.refrech = true;
      this.generalService.getDS('CRMActivity').subscribe((ds) => {
        this.CRM_DS = ds;
        this.refrech = false;
      });
    });
  }
  validForm() {
    console.log(this.CRM_DS.CRMActivity[0]);

    return (
      this.client.Tiers_code !== null &&
      this.CRM_DS.CRMActivity[0].CRMActivity_Date &&
      this.CRM_DS.CRMActivity[0].CRMActivity_Titre
    );
  }
}
